export enum ECountdownEndType {
    TOUCHES,
    TIME
}
